<div class="edit-page-root-container employee-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit || permission.can_add){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" appCodeInput
                                        [readonly]="itemInfo.id!==undefined && itemInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code is required</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is 50.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name is required</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is 100.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Hierarchy Order</mat-label>
                                    <input matInput type="number" formControlName="hierarchy_order">
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>Grade</mat-label>
                                    <input matInput type="number" formControlName="grade">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Foreground Color</mat-label>
                                    <input matInput formControlName="fg_color" type="color">
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>Background Color</mat-label>
                                    <input matInput formControlName="bg_color" type="color">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-checkbox formControlName="is_hq">Is HQ</mat-checkbox>
                            </div>
                            <div class="input-box-right">
                                <mat-checkbox formControlName="is_active">Is Active</mat-checkbox>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
